import authStoreTypes from './types';
import jwt_decode from 'jwt-decode';
import { IUserInformation } from '@/vuex/authorization/auth-store.interface';

const actions = {
    HANDLE_APP_CALLBACK_LOGIN(context: any, data: { jwt: string }): void {
        context.commit(authStoreTypes.mutations.SET_ACCESS_TOKEN, data.jwt);
    },
    DECODE_JWT(context: any): void {
        const decoded: any = jwt_decode(context.state.accessToken);
        const userInformation: IUserInformation | any = {};
        Object.keys(decoded).forEach((key: string) => {
            if (key.includes('/')) {
                const splittedKey = key.split('/');
                const newPropName = splittedKey[splittedKey.length - 1];
                userInformation[newPropName] = decoded[key];
            }
        });
    
        userInformation.deviceKey = decoded.DeviceKey;
        userInformation.lastVisitDateTimeUTC = decoded.LastVisitDateTimeUTC; 

        context.commit(authStoreTypes.mutations.SET_USERINFORMATION, userInformation);
    }
};

export default actions;
